import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 21l4 0","key":"svg-0"}],["path",{"d":"M10 21l0 -18","key":"svg-1"}],["path",{"d":"M10 4l9 4l-9 4","key":"svg-2"}]]

const IconPennant = createReactComponent('outline', 'pennant', 'Pennant', __iconNode);

export default IconPennant;